import React from 'react';
import classNameBind from 'classnames/bind';
import Icon from '../../../Icon';
import Tooltip from '../../../Tooltip';
import styles from './StatusIcon.module.css';

const bindClasses = classNameBind.bind(styles);

const StatusIcon = ({ type, color, tooltip = {} }) => (
  <Tooltip
    {...tooltip}
    position="top-start"
  >
    <div className={bindClasses('icon')}>
      <Icon name={type} color={color} />
    </div>
  </Tooltip>
);

export default StatusIcon;
